module.exports = __webpack_public_path__ + "static/img/K_clovers.3bd4480.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/K_clovers.svg
// module id = qo/b
// module chunks = 1